module.exports = (__webpack_require__(0))(51);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/UserCollection.js from dll-reference girder_lib
// module id = 175
// module chunks = 0